/* ADD Knowledge categories */
export const START_LESSON = "START_LESSON"
export const START_LESSON_SUCCESS = "START_LESSON_SUCCESS"
export const START_LESSON_CLEAN = "START_LESSON_CLEAN"
export const START_LESSON_ERROR = "START_LESSON_ERROR"
